import styled from 'styled-components';

import { screenReaderOnly } from 'utils/style/screen-reader-only';

export const HiddenLegend = styled.legend`
  ${screenReaderOnly};
`;
